import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import AdminDataTable from "./AdminDataTable";
import Swal from "sweetalert2";
import { FaList, FaWallet } from "react-icons/fa";
import AdminPageHeader from "./AdminPageHeader";
import Navigation from "./Navigation";

function Balance() {
    const [balances, setBalances] = useState([]);
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('sessionToken');
    const fetchBalance = async (status)=>{
        setLoading(true);
        try{
            const res = await fetch(
                `${process.env.REACT_APP_API_PRODUCT_URL}api/balance/all`,
                    {
                    headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                }
            );
            if (!res.ok) {
                throw new Error("Gagal fetch data deposit");
            }
            const data = await res.json();
            setBalances(data.balances || []);
        }catch(err){
            console.error(err);
            Swal.fire("Error", "Gagal mengambil data balance", "error");
        }finally {
            setLoading(false);
        }
    }
    const columns =[
        {
            name:"ID",
            selector: (row) => row.id,
            sortable: true,
            width: "80px",
        },
        {
            name:"Outlet",
            sortable: true,
            cell: (row) => (
              <div className="table-identity">
                <span className="table-identity__avatar">
                  {String(row.outlet_id).slice(0, 2).toUpperCase()}
                </span>
                <span className="table-identity__meta">
                  <strong>Outlet #{row.outlet_id}</strong>
                  <small>Current balance snapshot</small>
                </span>
              </div>
            ),
        },
        {
            name:"Balance",
            selector: (row) => row.balance.toLocaleString("id-ID"),
            sortable: true,
            right: true,
            cell: (row) => (
              <span className="table-identity__meta">
                <strong>Rp {row.balance.toLocaleString("id-ID")}</strong>
                <small>Saldo outlet tersedia</small>
              </span>
            ),
        }
    ]
    useEffect(() => {
        fetchBalance();
    }, []);
  return (
    <div>
      <Navigation />
      <Container fluid className="admin-page-shell mt-4 px-4">
        <AdminPageHeader
          icon={FaWallet}
          eyebrow="Finance snapshot"
          title="Outlet Balance"
          description="Lihat ringkasan saldo tiap outlet dalam tampilan yang lebih bersih dan mudah dibaca."
          breadcrumbs={[
            { label: 'Dashboard', to: '/dashboardadmin' },
            { label: 'Outlet Balance' },
          ]}
          meta={(
            <span className="soft-stat">
              <FaList /> {balances.length} outlets
            </span>
          )}
        />
        <AdminDataTable
          columns={columns}
          data={balances}
          progressPending={loading}
          pagination
          highlightOnHover
          striped
          dense
          emptyTitle="No balance data found"
          emptyDescription="Belum ada data saldo outlet yang bisa ditampilkan."
        />
      </Container>
    </div>
  );
}

export default Balance;
